import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { Hero } from './components/Hero';
import { OpeningHook } from './components/OpeningHook';
const Problem = lazy(() => import('./components/Problem').then(m => ({
  default: m.Problem
})));
const Solution = lazy(() => import('./components/Solution').then(m => ({
  default: m.Solution
})));
const WhyItWorks = lazy(() => import('./components/WhyItWorks').then(m => ({
  default: m.WhyItWorks
})));
const Roadmap = lazy(() => import('./components/Roadmap').then(m => ({
  default: m.Roadmap
})));
const Bonuses = lazy(() => import('./components/Bonuses').then(m => ({
  default: m.Bonuses
})));
const TargetAudience = lazy(() => import('./components/TargetAudience').then(m => ({
  default: m.TargetAudience
})));
const HowItWorks = lazy(() => import('./components/HowItWorks').then(m => ({
  default: m.HowItWorks
})));
const Testimonials = lazy(() => import('./components/Testimonials').then(m => ({
  default: m.Testimonials
})));
const FAQ = lazy(() => import('./components/FAQ').then(m => ({
  default: m.FAQ
})));
const Pricing = lazy(() => import('./components/Pricing').then(m => ({
  default: m.Pricing
})));
export function App() {
  useEffect(() => {
    // Meta Pixel
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1293149622738671');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    // noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=1293149622738671&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
  }, []);
  return <div className="min-h-screen bg-brand-dark text-slate-200 font-sans selection:bg-brand-gold/30 selection:text-white" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <OpeningHook data-id="element-3" />
        <Suspense fallback={<div className="min-h-[200px]" data-id="element-5" />} data-id="element-4">
          <Problem data-id="element-6" />
          <Solution data-id="element-7" />
          <WhyItWorks data-id="element-8" />
          <Bonuses data-id="element-9" />
          <TargetAudience data-id="element-10" />
          <Roadmap data-id="element-11" />
          <HowItWorks data-id="element-12" />
          <Testimonials data-id="element-13" />
          <FAQ data-id="element-14" />
          <Pricing data-id="element-15" />
        </Suspense>
      </main>

      <footer className="bg-brand-darker py-8 border-t border-slate-800 text-center text-slate-500 text-sm" data-id="element-16">
        <div className="max-w-6xl mx-auto px-6" data-id="element-17">
          <p data-id="element-18">
            © {new Date().getFullYear()} Networker Magnético. Todos los
            derechos reservados.
          </p>
          <p className="mt-2 text-xs opacity-60 max-w-2xl mx-auto" data-id="element-19">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </footer>
    </div>;
}